import { colors } from "src/styles";
import styled, { css } from "styled-components";

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  .spinner-border-sm {
    margin-right: 10px;
  }
`;

export const HeaderTitle = styled.p<{ $isMobile: number; isteampage?: number }>`
  font-size: 20px;
  margin-right: ${({ isteampage }) => (isteampage ? "8px" : "100px")};
  color: ${colors.grey.dark};

  ${({ $isMobile }: { $isMobile: number }) => $isMobile && `font-size: 12px; margin-right: 10px;`}
`;

export const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.grey.light1};
  padding: 10px;

  ${(props: { $isMobile: boolean }) =>
    props.$isMobile &&
    css`
      margin-bottom: 20px;
    `}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  & > div > button {
    color: ${colors.white.default};
  }
`;

export const OnSiteStatus = styled.p<{ isonsite: number }>`
  font-size: 16px;
  font-weight: 400;
  color: ${({ isonsite }: { isonsite: number }) => (isonsite ? `${colors.green.default}` : `${colors.grey.light5}`)};
`;

export const FlexInnerContainer = styled.div`
  display: flex;
  align-items: center;
`;
